import React, { useState } from "react";
import { LogIn } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const [busy, setBusy] = useState(false);

  const startGoogle = () => {
    setBusy(true);
    const redirectUrl = window.location.origin + "/";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <div className="min-h-screen bg-bg-base text-ink flex items-center justify-center p-8">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-12">
          <div className="w-8 h-8 bg-amber" />
          <div className="mono text-2xs uppercase tracking-[0.2em] text-ink-dim">
            Production Schedule
          </div>
        </div>

        <h1 className="text-3xl font-semibold tracking-tight mb-2">Open the console</h1>
        <p className="text-ink-dim text-sm mb-10">Continue with your Google account.</p>

        <button
          onClick={startGoogle}
          disabled={busy}
          data-testid="login-google-btn"
          className="btn-primary w-full justify-center"
        >
          <LogIn className="w-4 h-4" />
          {busy ? "Redirecting…" : "Continue with Google"}
        </button>
      </div>
    </div>
  );
}
